export default "__VITE_PUBLIC_ASSET__a144ad34__"